import { render, staticRenderFns } from "./TablePedidos.vue?vue&type=template&id=f1cc13fe&scoped=true&"
import script from "./TablePedidos.vue?vue&type=script&lang=js&"
export * from "./TablePedidos.vue?vue&type=script&lang=js&"
import style0 from "./TablePedidos.vue?vue&type=style&index=0&id=f1cc13fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cc13fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VIcon,VProgressCircular,VTextField})
